export const publicSupport = {
  supportEmail: 'support@bizcore.com',
  salesEmail: 'sales@bizcore.com',
  securityEmail: 'security@bizcore.com',
  responseTime: 'We aim to respond within 1 business day during onboarding and pilot rollout.',
};

export const publicLegalNotice =
  'This page is a practical product starter and should be reviewed with legal and operations before general launch.';
